// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_noAQk {
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  display:flex;
  flex-direction:column;
}
.header_V9n7_ {
  padding : 10px 20px;
  text-align:right;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  border-bottom: 5px solid var( --background );
}

.leftIcon_iQRyk {
  font-size : 24px;
  padding : 10px;
  color : #000;
}

.indicator__WUH2 {

}

@keyframes pulsate_gQpJP {
  from { font-style: 14px; }
  to { font-size:18px; }
}

.status-started_aJtSC {
  animation-duration: 0.5s;
  animation-direction: alternate-reverse;
  animation-iteration-count: infinite;
}

.screen_bu7Qw .addNetwork_btxY3 {
  border-radius:0;
  height : 40px;
  padding : 8px 16px;
  margin : 0 5px;

  font-size: 12px;
  border-radius: 2px;
  text-shadow: none;
  border: 1px solid var( --green );
}

.screen_bu7Qw .addNetwork_btxY3:focus {
  outline: none;
  border-color:var( --purple );
  background: var( --green );
}

.screen_bu7Qw .addNetwork_btxY3:active:focus {
  outline: none;
  border-color:var( --purple );
}

.screen_bu7Qw .addNetwork_btxY3:hover {
  outline: none;
  box-shadow: none;
  background: var( --green-light );
}

.screen_bu7Qw .addNetwork_btxY3:active {
  outline: none;
  box-shadow: none;
}

.list_QWszj {
  position:relative;
  height:100%;
}

.right_cEYkk { 
  position :relative;
  height:100%;
  min-width:400px;
  overflow-y:auto;
  background: var( --background );
  border-left: 1px solid var( --border-color );
}


.noItems_BW_He {
  padding : 20px;
}

`, "",{"version":3,"sources":["webpack://./src/screens/network/style.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,KAAK;EACL,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;;AAEA;;AAEA;;AAEA;EACE,OAAO,gBAAgB,EAAE;EACzB,KAAK,cAAc,EAAE;AACvB;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,4CAA4C;AAC9C;;;AAGA;EACE,cAAc;AAChB","sourcesContent":["@import \"../../style/theme.css\";\n\n.content {\n  position:absolute;\n  top:0;\n  left:0;\n  right:0;\n  bottom:0;\n  display:flex;\n  flex-direction:column;\n}\n.header {\n  padding : 10px 20px;\n  text-align:right;\n  display:flex;\n  flex-direction:row;\n  justify-content:space-between;\n  align-items:center;\n  border-bottom: 5px solid var( --background );\n}\n\n.leftIcon {\n  font-size : 24px;\n  padding : 10px;\n  color : #000;\n}\n\n.indicator {\n\n}\n\n@keyframes pulsate {\n  from { font-style: 14px; }\n  to { font-size:18px; }\n}\n\n.status-started {\n  animation-duration: 0.5s;\n  animation-direction: alternate-reverse;\n  animation-iteration-count: infinite;\n}\n\n.screen .addNetwork {\n  border-radius:0;\n  height : 40px;\n  padding : 8px 16px;\n  margin : 0 5px;\n\n  font-size: 12px;\n  border-radius: 2px;\n  text-shadow: none;\n  border: 1px solid var( --green );\n}\n\n.screen .addNetwork:focus {\n  outline: none;\n  border-color:var( --purple );\n  background: var( --green );\n}\n\n.screen .addNetwork:active:focus {\n  outline: none;\n  border-color:var( --purple );\n}\n\n.screen .addNetwork:hover {\n  outline: none;\n  box-shadow: none;\n  background: var( --green-light );\n}\n\n.screen .addNetwork:active {\n  outline: none;\n  box-shadow: none;\n}\n\n.list {\n  position:relative;\n  height:100%;\n}\n\n.right { \n  position :relative;\n  height:100%;\n  min-width:400px;\n  overflow-y:auto;\n  background: var( --background );\n  border-left: 1px solid var( --border-color );\n}\n\n\n.noItems {\n  padding : 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_noAQk`,
	"header": `header_V9n7_`,
	"leftIcon": `leftIcon_iQRyk`,
	"indicator": `indicator__WUH2`,
	"status-started": `status-started_aJtSC`,
	"screen": `screen_bu7Qw`,
	"addNetwork": `addNetwork_btxY3`,
	"list": `list_QWszj`,
	"right": `right_cEYkk`,
	"noItems": `noItems_BW_He`,
	"pulsate": `pulsate_gQpJP`
};
export default ___CSS_LOADER_EXPORT___;
